import { UserDataStore } from './userDataStore';

export const userDataStore = new UserDataStore();
